export default {
  CREATED: 'CREATED',
  REGISTERED: 'REGISTERED',
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
};
